module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/allowances-details/allowances-details-grid/allowances-details-grid.component.css
// module id = ./src/app/hrms/payroll/allowances-details/allowances-details-grid/allowances-details-grid.component.css
// module chunks = main